import React, { useState } from "react";
import { Col, Container, Row, Modal, Button, Form } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import {
  CATEGORYREQUESTLIST,
  ACCEPTCATEGORY,
  GETVENDORTHERAPIST,
  REJECTCATEGORY,
} from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import { activeInactiveOptions } from "../../../utilities/const";
import { Link, useNavigate } from "react-router-dom";
import CustomPagination from "../../../components/Common/CustomPagination";
import { toast } from "react-toastify";
import RejectCategoryPop from "../../../components/Modals/RejectedCategoryPop";

const CategoryRequestData = () => {
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    refetch,
    deleteHandler,
  } = dataHandler({
    api: CATEGORYREQUESTLIST,
  });

  const navigate = useNavigate();
  const [vendorModal, setVendorModal] = useState({
    show: false,
    category: null,
    vendors: [],
  });

  const [rejectModal, setRejectModal] = useState({
    show: false,
    categoryId: null,
  });

  const [selectedVendors, setSelectedVendors] = useState([]);

  const openVendorModal = async (categoryItem) => {
    try {
      const res = await GETVENDORTHERAPIST({
        category: categoryItem.categoryId._id,
        limit: 1000, // el backend devuelve 10 por defecto: traer todos los terapeutas
      });
      if (res?.data?.status === "success") {
        setVendorModal({
          show: true,
          category: categoryItem,
          vendors: res.data?.data || [],
        });
      }
    } catch (err) {
      console.error("Error fetching vendors", err);
    }
  };

  const handleVendorSelect = (vendorId) => {
    setSelectedVendors((prev) => {
      if (prev.includes(vendorId)) {
        return prev.filter((id) => id !== vendorId);
      } else if (prev.length < 3) {
        return [...prev, vendorId];
      } else {
        toast.warning("You can select up to 3 vendors only.");
        return prev;
      }
    });
  };

  const handleAcceptCategory = async () => {
    try {
      const body = {
        _id: vendorModal?.category?._id,
        vendorIds: selectedVendors,
      };

      const res = await ACCEPTCATEGORY(body);
      if (res?.data?.status === "success") {
        toast.success("Category accepted successfully!");
        refetch();
        setVendorModal({ show: false, category: null, vendors: [] });
        setSelectedVendors([]);
      } else {
        toast.error(res?.data?.message || "Somethings went wrong!");
      }
    } catch (err) {
      console.error("Error accepting category", err);
    }
  };

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => {
        return <>{key < 9 ? `0${key + 1}` : key + 1}</>;
      },
    },
    {
      head: "Category Name",
      accessor: "catName",
      component: (item) => <p>{item?.categoryId?.catName}</p>,
    },
    {
      head: "User Name",
      accessor: "name",
      component: (item) => (
        <p>{item?.userId?.fname + " " + item?.userId?.lname}</p>
      ),
    },
    {
      head: "Description",
      accessor: "catDesc",
      component: (item) => <p>{item?.categoryId?.catDesc}</p>,
    },
    {
      head: "Created At",
      accessor: "date_created_utc",
      component: (item) => (
        <p>{moment(item.date_created_utc).format("YYYY-MM-DD hh:mm A")}</p>
      ),
    },

    {
      head: "Status",
      accessor: "status",
      component: (item) => (
        <span className="text-capitalize">{item?.status}</span>
      ),
    },

    {
      head: "Action",
      accessor: "Action",
      component: (item, key, arr) => (
        <div className="actionBtn d-flex align-items-center gap-10">
          <div
            className="border-0 p-0"
            variant="transparent"
            onClick={() => navigate(`/categoryrequest/detail/${item?._id}`)}
            style={{ cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="13"
              viewBox="0 0 21 13"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.1269 0.379883C6.00023 0.379883 2.81476 3.30125 1.26883 5.0114C0.614598 5.73509 0.23969 6.2714 0.23969 6.2714C0.0900251 6.48573 0.0900251 6.77233 0.23969 6.98666C0.23969 6.98666 0.534721 7.40936 1.05152 8.0024C2.50253 9.6674 5.79632 12.8782 10.1269 12.8782C14.572 12.8782 17.9291 9.49839 19.3181 7.87307C19.7642 7.35098 20.0152 6.98666 20.0152 6.98666C20.1649 6.77233 20.1649 6.48573 20.0152 6.2714C20.0152 6.2714 19.7398 5.87467 19.2535 5.31173C17.8276 3.6621 14.5055 0.379883 10.1269 0.379883ZM10.1269 1.62996C13.8634 1.62996 16.9827 4.59581 18.3074 6.12852C18.5725 6.43529 18.5974 6.48424 18.7089 6.63143C18.605 6.76803 18.593 6.79697 18.3671 7.06124C17.0781 8.56964 13.9201 11.6281 10.1269 11.6281C6.43137 11.6281 3.34181 8.72873 1.99268 7.18081C1.70294 6.8484 1.67185 6.78672 1.55443 6.63143C1.69037 6.45001 1.77636 6.31473 2.19543 5.85135C3.63536 4.25828 6.60534 1.62996 10.1269 1.62996ZM10.1269 2.88004C8.06297 2.88004 6.38027 4.56274 6.38027 6.62663C6.38027 8.69036 8.06297 10.378 10.1269 10.378C12.1906 10.378 13.8783 8.69036 13.8783 6.62663C13.8783 4.56274 12.1906 2.88004 10.1269 2.88004ZM10.1269 4.13127C11.5152 4.13127 12.6282 5.23814 12.6282 6.62663C12.6282 8.01496 11.5152 9.12794 10.1269 9.12794C8.73837 9.12794 7.6315 8.01496 7.6315 6.62663C7.6315 5.23814 8.73837 4.13127 10.1269 4.13127Z"
                fill="#645C5C"
              />
            </svg>
          </div>
        </div>
      ),
    },
    // {
    //   head: "Action",
    //   accessor: "Action",
    //   component: (item) => {
    //     return (
    //       <div className="d-flex align-items-center gap-2">
    //         {item?.status?.toLowerCase() === "pending" && (
    //           <>
    //             <button
    //               className="btn btn-sm btn-success"
    //               onClick={() => openVendorModal(item)}
    //             >
    //               Accept
    //             </button>

    //             <button
    //               className="btn btn-sm btn-danger"
    //               onClick={() =>
    //                 setRejectModal({ show: true, categoryId: item?._id })
    //               }
    //             >
    //               Reject
    //             </button>
    //           </>
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];

  const handleRejectCategory = async () => {
    try {
      const res = await REJECTCATEGORY({ _id: rejectModal.categoryId });
      if (res?.data?.status === "success") {
        toast.success("Category rejected successfully!");
        refetch();
        setRejectModal({ show: false, categoryId: null });
      } else {
        toast.error(res?.data?.message);
      }
    } catch (err) {
      console.error("Error rejecting category", err);
      toast.error("Failed to reject category!");
    }
  };

  return (
    <>
      <RejectCategoryPop
        show={rejectModal.show}
        setShow={(value) => setRejectModal({ show: value, categoryId: null })}
        confirmHandler={handleRejectCategory}
      />

      <Modal
        show={vendorModal.show}
        onHide={() =>
          setVendorModal({ show: false, category: null, vendors: [] })
        }
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Therapist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {vendorModal?.vendors?.length > 0 ? (
            vendorModal?.vendors?.map((vendor) => (
              <Form.Check
                key={vendor._id}
                type="checkbox"
                label={`${vendor.fname || ""} ${vendor.lname || ""}`}
                checked={selectedVendors.includes(vendor._id)}
                onChange={() => handleVendorSelect(vendor._id)}
              />
            ))
          ) : (
            <p>No Therapist found for this category.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() =>
              setVendorModal({ show: false, category: null, vendors: [] })
            }
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAcceptCategory}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <section className="promocode py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Assigned Therapist List{" "}
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    searchHandler={searchHandler}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>
                {/* <div className="right">
                  <Link
                    to="/signupquestion/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    Add New
                  </Link>
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CategoryRequestData;
